import {
    unstable_HistoryRouter as OriginalHistoryRouter,
    HistoryRouterProps as OriginalHistoryRouterProps,
} from 'react-router-dom';

import { HistoryContext } from '../contexts/HistoryContext';
import type { History } from '../buildHistory';

export type HistoryRouterProps = Omit<OriginalHistoryRouterProps, 'history'> & {
    history: History;
};

export function HistoryRouter(props: HistoryRouterProps) {
    return (
        <HistoryContext.Provider value={props.history}>
            <OriginalHistoryRouter {...props} />
        </HistoryContext.Provider>
    );
}
